export enum CartDeliveryAction {
  SetCartAuctions = 'setCartAuctions',
  SetAuctionsAvailableDeliveries = 'setAuctionsAvailableDeliveries',
  SetIsPopupVisible = 'setIsPopupVisible',
  SetCurrentAddress = 'setCurrentAddress',
  SetAddressFormValues = 'setAddressFormValues',
  SetChosenAuctionDeliverySettings = 'setChosenAuctionDeliverySettings',
  SetCommentToOrder = 'setCommentToOrder'
}
